<div class="modal-header">
  <h4>Nueva solicitud MTO-FDOC-05</h4>

  <button
    type="button"
    class="close"
    aria-label="Close button"
    aria-describedby="modal-title"
    (click)="modal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <typeahead-http-done
        (modelOutput)="addModel($event)"
      ></typeahead-http-done>
    </div>

    <div class="form-group">
      <label for="customerName"
        >Nombre del operador<span class="text-danger">*</span></label
      >
      <input
        type="text"
        formControlName="customerName"
        class="form-control"
        [ngClass]="{ 'is-invalid': submitted && f.customerName.errors }"
        [readonly]="true"
      />
      <div *ngIf="submitted && f.customerName.errors" class="invalid-feedback">
        <div *ngIf="f.customerName.errors.required">
          Se necesita buscar operador
        </div>
      </div>
    </div>

    <div class="form-group">
      <label for="legalName"
        >Representante legal<span class="text-danger">*</span></label
      >
      <input
        type="text"
        formControlName="legalName"
        class="form-control"
        [ngClass]="{
          'is-invalid': submitted && f.legalName.errors
        }"
        [readonly]="true"
      />
      <div *ngIf="submitted && f.legalName.errors" class="invalid-feedback">
        <div *ngIf="f.legalName.errors.required">
          Se necesita buscar operador
        </div>
      </div>
    </div>

    <div class="form-group">
      <label for="folioFollowing">Folio/RECO<span class="text-danger">*</span></label
      >
      <input
        type="text"
        formControlName="folioFollowing"
        class="form-control"
        [ngClass]="{
          'is-invalid': f.folioFollowing.touched && f.folioFollowing.errors
        }"
      />
      <div *ngIf="f.folioFollowing.touched && f.folioFollowing.errors" class="invalid-feedback">
        <div *ngIf="f.folioFollowing.errors.required">
          El folio/RECO es requerido
        </div>

        <div *ngIf="f.folioFollowing.errors.folioTaken">
          El folio/RECO ya está en uso
        </div>

        <div *ngIf="f.folioFollowing.pending" class="text-muted">
          Validando folio...
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="modal.dismiss('cancel click')"
      >
        Cancelar
      </button>
      <button
        [disabled]="loading || form.pending"
        type="button"
        ngbAutofocus
        class="btn btn-success"
        (click)="onSubmit()"
      >
        <span
          *ngIf="loading"
          class="spinner-border spinner-border-sm mr-1"
        ></span>
        Aceptar
      </button>
    </div>
  </form>
</div>
